module.exports = __webpack_public_path__ + "868d168919c0cba22399a6530c6a6993.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-2.png
// module id = 3678
// module chunks = 0